import React from 'react'
import { useLocale, Card, StarRating, Spinner } from '@betina/ui'
import { useQuery } from '../hooks/useApi.js'
import { dishLogApi } from '../lib/api.js'

export function History() {
  const { t, locale } = useLocale()

  const { data: logs, loading } = useQuery(
    () => dishLogApi.list(50),
    []
  )

  const grouped = (logs ?? []).reduce((acc, log) => {
    const date = new Date(log.prepared_at * 1000).toLocaleDateString(locale, {
      weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
    })
    if (!acc[date]) acc[date] = []
    acc[date].push(log)
    return acc
  }, {})

  return (
    <div className="p-4 space-y-4">
      <h1 className="text-xl font-bold text-gray-800">{t('history')}</h1>

      {loading ? (
        <div className="flex justify-center py-10"><Spinner /></div>
      ) : Object.keys(grouped).length === 0 ? (
        <Card className="text-center py-10">
          <p className="text-3xl mb-2">📋</p>
          <p className="text-gray-500 text-sm">Aucun plat préparé pour l'instant</p>
          <p className="text-gray-400 text-xs mt-1">
            Marquez des repas comme "préparés" dans le planning pour les voir ici
          </p>
        </Card>
      ) : (
        Object.entries(grouped).map(([date, dayLogs]) => (
          <div key={date}>
            <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2 capitalize">
              {date}
            </h3>
            <div className="space-y-2">
              {dayLogs.map((log) => (
                <Card key={log.id}>
                  <div className="flex items-start gap-3">
                    <span className="text-2xl">🍽️</span>
                    <div className="flex-1 min-w-0">
                      <p className="font-medium text-gray-800 text-sm">{log.name}</p>
                      <div className="flex items-center gap-3 mt-1">
                        <span className="text-xs text-gray-400">
                          👥 {log.servings_made} portion{log.servings_made > 1 ? 's' : ''}
                        </span>
                        {log.notes && (
                          <span className="text-xs text-gray-500 italic truncate">{log.notes}</span>
                        )}
                      </div>
                    </div>
                  </div>
                </Card>
              ))}
            </div>
          </div>
        ))
      )}
    </div>
  )
}
